<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">پرینت اطلاعت صندوق دار</h5>
                <div style="flex: 1"></div>
                <button class="btn btn-primary ml-2" @click="print">
                <i class="fa fa-print"></i>
                </button>
                <Back url="/admin/shop/orders" />
            </div>
            <div class="card-body">
                <div id="print">  
                    <b-container class="d-flex justify-content-center mt-5 mb-5">  
                        <b-row>  
                            <b-col class="d-flex justify-content-center">  
                                <div class="d-flex align-items-center mt-3">  
                                    <span class="alijenab" style="font-size: 20px; font-weight: bold; color: #333;">فروشگاه ویکو</span>  
                                </div>  
                            </b-col>  
                        </b-row>  
                    </b-container>  
                    <br>
                    <b-container class="d-flex justify-content-center">  
                        <b-row>  
                            <b-col class="d-flex justify-content-center">  
                                <div class="d-flex align-items-center">  
                                    <span>گزارش فروش صندوق دار</span>
                                </div>  
                            </b-col>  
                        </b-row>  
                    </b-container>  
                    <br>
                    <hr style="border: 1px solid #000;"> 
                    <div class="mb-1 mt-3">  
                        <br>
                        <div class="col-7 mb-3">  
                            <div style="margin-right: 0px;" class="mb-3">  
                                <span class="md-text">صندوق دار :</span>  
                                <span class="font-weight-bold large-text"> {{ parsedData.admin.name }} </span>  
                            </div>  
                            <div style="margin-right: 0px;" class="mb-3">  
                                <span class="font-weight-bold">  
                                    <span class="md-text">تاریخ:</span>  
                                    <span dir="ltr" class="large-text">{{ parsedData.reports_today.date }}</span>  
                                </span>  
                            </div>  
                        </div>  
                    </div>
                    <br>
                    <b-container class="d-flex justify-content-center mt-5">  
                        <b-row class="w-100">  
                            <b-col class="d-flex flex-column align-items-start gap-2" style="flex: 1; min-width: 250px;">  
                                <div class="d-flex align-items-center mt-3">  
                                    <strong>فروش امروز (ریال) :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.total_sales_today * 10 | price}} ریال</span>  
                                </div>  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>مرجوعی (ریال):</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.sum_refund_today * 10 | price}} ریال</span>  
                                </div>  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>تخفیفات (ریال) :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.today_sales_discount * 10 | price}} ریال</span>  
                                </div>  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>باقی مانده (ریال) :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.totalRemainderAmount * 10 | price}} ریال</span>  
                                </div>  
                            </b-col>  
                            <br>
                            <b-col class="d-flex flex-column align-items-start gap-2" style="flex: 1; min-width: 250px;">  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>فروش امروز نقدی (ریال) :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.total_sales_cash * 10 | price}} ریال</span>  
                                </div>  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>کارت به کارت (ریال) :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.total_sales_card_by_card * 10 | price}} ریال</span>  
                                </div>  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>فروش امروز با پوز (ریال) :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.total_sales_pos * 10 | price}} ریال</span>  
                                </div>  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>استفاده از کیف پول (ریال) :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.total_wallet * 10 | price}} ریال</span>  
                                </div>  
                            </b-col>  
                            <br>

                            <b-col class="d-flex flex-column align-items-start gap-2" style="flex: 1; min-width: 250px;">  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>مبلغ تعویضی (ریال) :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.todayChangesAmount * 10 | price}} ریال</span>  
                                </div>  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>تعداد مرجوعی ها :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.today_sales_refund_quantity | price}}</span>  
                                </div>  
                                <div class="d-flex align-items-center mt-5">  
                                    <strong>تعداد تعویضی ها :</strong>  
                                    <span class="large-text ml-2">{{ parsedData.reports_today.todayChangesCount | price}}</span>  
                                </div>  
                            </b-col>  
                        </b-row>  
                    </b-container>  
                </div>  
            </div>
        </div>
    </main>
</template>
<script>
    import Loading from "@@/core/components/shared/Loading/Loading";
    import configProvider from "@@/core/configProvider";
    import Back from "@@/core/components/shared/Back/Back";
    import { Printd } from "printd";
    import styles from "@@/core/pages/physicalShop/getStyles";

    export default {
        name: "PrintTransaction",
        configProvider,
        components: { Loading, Back },
        props: {  
        dataAll: {  
            type: String,  
            required: false  
            }  
        }, 
        data() {
            return {
                item: null,
                parsedData: [],
            };
        },
        computed: {
            dataMiniOrder() {  
                return this.parsedData; 
            }  
        },
        mounted() {
            const dataAllQuery = this.$route.query.dataAll;  
            if (dataAllQuery) {  
                this.parsedData = JSON.parse(dataAllQuery);  
            } else {  
                console.warn("dataAll is missing from query params.");  
            }  
        },
        methods: {
            getPriceName() {
                return configProvider.get("physicalShop.printPrice") === "rial"
                ? "ریال"
                : "تومان";
            },
            getPrice(price) {
                return configProvider.get("physicalShop.printPrice") === "rial"
                ? price * 10
                : price;
            },
            print() {
                const d = new Printd();
                let _styles;
                const _barcodePrint = `
                    #print {
                    position: relative;
                    }
                    .barcode-print {
                    position: absolute;
                    top: 0;
                    left:0;
                    }
                    .row-1 {
                    margin-bottom: 2rem !important;
                    }
                `;
                if (configProvider.get("print_font")) {
                    _styles =
                    styles +
                    "@font-face{font-family:'yekan-bakh';src:url(" +
                    configProvider.get("print_font") +
                    ") format('woff');font-weight:normal;font-style:normal;}";
                } else {
                    _styles = styles;
                }
                d.print(document.getElementById("print"), [_styles, _barcodePrint]);
                },
        },
    };
</script>
<style scoped>
    .whitePre {
        white-space: pre-wrap;
    }
    .card.little .card-header {
        font-weight: bold;
    }
    @media print {  
        hr {  
            display: block; 
            width: 80%;
            margin: 20px auto; 
            border: 2px solid #333;
        }
    }  
</style>
<style>
    .black-bg {
        background: #363636;
        color: white;
    }

    .row-1 {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .row-2-header {
        padding: 4px 0;
        text-align: center;
        font-weight: bold;
    }

    .row-4-item {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    #print {
        position: relative;
    }
    .barcode-print {
        position: absolute;
        top: 0;
        left: 0;
    }
</style>